import { render, staticRenderFns } from "./lightIndex.vue?vue&type=template&id=57c91a94&scoped=true&"
import script from "./lightIndex.vue?vue&type=script&lang=js&"
export * from "./lightIndex.vue?vue&type=script&lang=js&"
import style0 from "./lightIndex.vue?vue&type=style&index=0&id=57c91a94&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c91a94",
  null
  
)

export default component.exports